import { render, staticRenderFns } from "./DepartamentForm.vue?vue&type=template&id=e634d908"
import script from "./DepartamentForm.vue?vue&type=script&lang=js"
export * from "./DepartamentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports